// The person's saved order over the tabs they can see now. A tab the order doesn't know
// yet (newly enabled module, new permission) goes after the tab it follows by default.
export const applyTabOrder = (tabs, order) => {
    if (!order?.length) return tabs

    const rank = new Map(order.map((id, i) => [id, i]))
    const ordered = tabs.filter((t) => rank.has(t.id)).sort((a, b) => rank.get(a.id) - rank.get(b.id))

    tabs.forEach((tab, i) => {
        if (rank.has(tab.id)) return

        const after = i > 0 ? ordered.findIndex((t) => t.id === tabs[i - 1].id) : -1
        ordered.splice(after + 1, 0, tab)
    })

    return ordered
}
